export const SESSION_MESSAGE_STORAGE_KEY = 'shopora_admin_session_message'

export const SESSION_EXPIRED_MESSAGE =
  'Your session has expired. Please sign in again to continue.'

export const FORBIDDEN_ROLE_SESSION_MESSAGE =
  'This panel is for platform super admins only. Please sign in with a super admin account.'

export function readSessionMessage(): string | null {
  try {
    return sessionStorage.getItem(SESSION_MESSAGE_STORAGE_KEY)
  } catch {
    return null
  }
}

export function writeSessionMessage(message: string): void {
  try {
    sessionStorage.setItem(SESSION_MESSAGE_STORAGE_KEY, message)
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearSessionMessage(): void {
  try {
    sessionStorage.removeItem(SESSION_MESSAGE_STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
